<template>
	<div id="maintenance" class="error">
		<div class="logo-container">
			<svgIcon icon-holder-class="logo" icon-id="nexon-logo" />
		</div>

		<img class="error-logo" src="@/images/error/logo-maintenance.png" />

		<h1 class="heading-normal text-white text-center">
			{{ $t('main.error.maintenance') }}
		</h1>

		<p class="error-desc text-center">
			{{ $t('main.error.maintenance-desc') }}
		</p>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
	name: 'Maintenance',
	components: {
		svgIcon,
	},
};
</script>
